import { DEFAULT_OPTIONS } from './components/TemplateModal'
import { EMPTY_RULE, NULL_ROBOT, RuleType } from './model'

type OptionType = {
  value: string
  label: string | React.ReactNode
  text?: string
  children?: OptionType[]
}

// 用于获取Cascader所需的value格式
export const cascaderValueMap = (value?: OptionType[]) => {
  const map = new Map<string, string[]>()
  if (!value) return map

  function setMap(options: OptionType[], parentId?: string) {
    options.forEach(v => {
      map.set(v.value, [...((parentId && map.get(parentId)) || []), v.value])

      if (!v.children?.length) return

      setMap(v.children, v.value)
    })
  }
  setMap(value)

  return map
}

// 用于获取所选值下的所有叶子节点
export const flatValueMap = (value?: OptionType[]) => {
  const map = new Map<string, { value: string; label: string }[]>()
  if (!value) return map

  function setMap(options: OptionType[]) {
    options.forEach(v => {
      if (!v.children?.length) {
        map.set(v.value, [
          { value: v.value, label: v.text || (typeof v.label === 'string' ? v.label : '') },
        ])
        return
      }

      setMap(v.children)

      map.set(v.value, v.children.map(child => map.get(child.value) || []).flat())
    })
  }
  setMap(value)

  return map
}

export const formatRuleList = (data: RuleType[], platformsData: string[]) => {
  const platformRules: Record<string, RuleType[]> = {}
  platformsData.forEach((v: string) => {
    platformRules[v] = []
  })
  data.reverse().forEach(v => {
    if (!v) return
    platformRules[v.platform]?.unshift({
      ...v,
      app_robot_id: v.app_robot_id === NULL_ROBOT ? undefined : v.app_robot_id,
      robot_name: v.robot_name || '群名称：系统初始化',
      notify_style: v.notify_style || [...DEFAULT_OPTIONS],
    })
  })

  return platformsData.map(v => {
    const cur = platformRules[v]

    if (cur && cur.length > 0) {
      return cur
    }

    // 平台没有数据才会添加空规则
    return [{ ...EMPTY_RULE, platform: v }]
  })
}
